import { useMutation, useQueryClient } from '@tanstack/react-query'
import { haptic } from '@/shared/utils/haptics'
import { groceryListService } from './grocery-list.service'
import { GROCERY_LIST_QUERY_KEY } from './useGroceryList'
import type { GroceryList } from './types'

export function useGenerateGroceryList() {
  const queryClient = useQueryClient()
  const queryKey = GROCERY_LIST_QUERY_KEY

  return useMutation({
    mutationFn: () => groceryListService.generateGroceryList(),

    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey })
      const snapshot = queryClient.getQueryData<GroceryList>(queryKey)
      return { snapshot }
    },

    onSuccess: () => {
      haptic('medium')
    },

    onError: (_error, _variables, context) => {
      if (context?.snapshot !== undefined) {
        queryClient.setQueryData(queryKey, context.snapshot)
      }
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey })
    },
  })
}
